import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { S3UploadPayload, S3UploadService } from './s3-upload.service';
import { AppState, documentFileSelectors } from '@app/state';
import { Store } from '@ngrx/store';
import { filter, map, Observable, pairwise, take } from 'rxjs';
import { DocumentFile } from '@app/models';
import { Update } from '@briebug/ngrx-auto-entity';

export interface CreateDocumentFilePayload {
  documentFile: DocumentFile;
  file: File;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentFileService {
  constructor(
    private http: HttpClient,
    private api: ApiService,
    private s3Uploader: S3UploadService,
    private store$: Store<AppState>
  ) {}

  getLink(documentId: string): Observable<string> {
    return this.http
      .get<DocumentFile>(`${this.api.url}/documents/${documentId}`)
      .pipe(map(result => result.document));
  }

  create(payload: DocumentFile): Observable<DocumentFile> {
    return this.http.post<DocumentFile>(`${this.api.url}/documents`, payload);
  }

  uploadFile(payload: CreateDocumentFilePayload) {
    console.log(`Uploading to ${payload.documentFile.uploadUrl}`);
    const s3Payload: S3UploadPayload = {
      url: payload.documentFile.uploadUrl,
      file: payload.file,
      messages: {
        connected: 'Connected...',
        uploadProgress: `Uploading ${payload.file.name}...`,
        uploadProgressComplete: `Processing ${payload.file.name} on server...`,
      },
      entityType: 'DocumentFile',
      entityId: payload.documentFile.id,
      onComplete: () => {
        const documentFile: DocumentFile = {
          ...payload.documentFile,
          fileExists: true,
        };
        this.store$.dispatch(new Update(DocumentFile, documentFile));
        return this.store$.select(documentFileSelectors.selectIsSaving).pipe(
          pairwise(),
          filter(([a, b]) => a === true && b === false),
          take(1)
        );
      },
    };
    return this.s3Uploader.upload(s3Payload);
  }

  continueUpload(id: string, file: File) {
    this.http
      .get<DocumentFile>(`${this.api.url}/documents/${id}`)
      .subscribe(documentFile => {
        this.uploadFile({
          documentFile,
          file,
        });
      });
  }
}
